var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusBlackIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.779,
    height: 13.779,
    viewBox: "0 0 13.779 13.779",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-add",
    transform: "translate(-7 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M13.148,20.779A1.085,1.085,0,0,1,12,19.631V8.148a1.148,1.148,0,0,1,2.3,0V19.631A1.085,1.085,0,0,1,13.148,20.779Z",
    transform: "translate(0.741 0)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M7,13.148A1.085,1.085,0,0,1,8.148,12H19.631a1.148,1.148,0,0,1,0,2.3H8.148A1.085,1.085,0,0,1,7,13.148Z",
    transform: "translate(0 0.741)",
    fill: "#000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlackIcon);
export default __webpack_public_path__ + "static/media/plusBlackIcon.368ff7bd41ee826239e7a623950c4e83.svg";
export { ForwardRef as ReactComponent };